/**
 * Words the chat masks and names refuse (ADR 0037). Compared after
 * `normaliseWord` (`rules/word-filter.ts`): lower case, no accents, repeated
 * letters collapsed, digits read as the letters they mimic. So `connard`
 * also catches `CONNNARD` and `c0nnard`; the list holds each word once, in
 * its plain form, without its plural.
 *
 * Short on purpose, and French first: a wide list masks honest words
 * (« député » holds « pute »). Matching is by whole word, never by substring.
 */
export const BANNED_WORDS = [
    // Insultes
    'connard',
    'connasse',
    'encule',
    'enculer',
    'salope',
    'salopard',
    'pute',
    'putes',
    'batard',
    'fdp',
    'ntm',
    'nique',
    'niquer',
    'niquez',
    'suceur',
    'suceuse',
    // Injures homophobes et transphobes
    'pd',
    'pede',
    'tarlouze',
    'tapette',
    'gouine',
    'fiotte',
    // Injures racistes et antisémites
    'negre',
    'negro',
    'negresse',
    'bougnoule',
    'bamboula',
    'youpin',
    'feuj',
    'niakoue',
    'chinetoque',
    'bridé',
    // English, heard on any server
    'fuck',
    'fucking',
    'fucker',
    'motherfucker',
    'bitch',
    'cunt',
    'nigger',
    'nigga',
    'faggot',
    'fag',
    'retard',
    'whore',
    'slut',
    'asshole',
    'kike',
    'chink',
    'spic',
];
//# sourceMappingURL=banned-words.js.map